import React, { useState, useRef, useEffect } from 'react';
import { withStyles, InputBase } from '@material-ui/core';
import { Search as SearchIcon, CancelOutlined as Clear } from '@material-ui/icons';
import styles from '../../layout/layoutHeader/components/styles';
import { debounce } from 'lodash';
import appConstants from '../../appConstants';

/* 
TODO: Currently, we have two additional search boxes apart from this one: 1) located in the grid header, and 2) used for driver performance. 
These can be combined, allowing us to remove the customSearchClass from this component in the future.
*/
const SearchBox = ({ classes, onChange, onEnter, customSearchClass = '' }) => {
  const [searchText, setSearchText] = useState('');
  const debouncedHandler = useRef();

  useEffect(() => {
    debouncedHandler.current = debounce(onChange, appConstants.SEARCH_DEBOUNCE_DELAY);
    return () => {
      debouncedHandler.current.cancel();
    };
  }, []);

  const handleSearchTextChange = (event) => {
    const text = event.target.value;
    setSearchText(text);
    debouncedHandler.current(text);
  };

  const handleClear = () => {
    setSearchText('');
    debouncedHandler.current.cancel();
    onChange('');
  };

  const handleKeyDown = (event) => {
    // Check if the Enter key is pressed
    if (event.key === 'Enter') {
      if (onEnter) {
        onEnter(); // Call the onEnter function with the current search text
      }
    }
  }

  return (
    <div className={`${classes.search} ${classes.iconLayout} ${customSearchClass}`}>
      <div className={classes.searchIcon}>
        <SearchIcon />
      </div>
      <InputBase
        placeholder="Search…"
        classes={{
          root: classes.inputRoot,
          input: classes.inputInput
        }}
        onChange={handleSearchTextChange}
        onKeyDown={handleKeyDown}
        value={searchText}
        endAdornment={
          <Clear
            classes={{
              root: `${classes.clearIcon} ${searchText ? classes.iconVisible : classes.iconHidden}`
            }}
            onClick={handleClear}
            display={searchText ? 'none' : 'block'}
          />
        }
      />
    </div>
  );
};

export default withStyles(styles)(React.memo(SearchBox));
